module.exports = __webpack_public_path__ + "img/w17.45dc965a.svg";